import { ReactNode, useState } from "react";
import { AuthLoadingContext } from "./authLoadingContext";

interface AuthLoadingProviderProps {
    children: ReactNode;
}

export const AuthLoadingProvider = ({ children }: AuthLoadingProviderProps) => {
    const [isLoading, setLoading] = useState(false);

    return (
        <AuthLoadingContext.Provider value={{ setAuthLoading: setLoading, isAuthLoading: isLoading }}>
            {children}
        </AuthLoadingContext.Provider>
    );
};